import { useContext } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import ErrorPage from '../components/common/ErrorPage';
import ExtractionBatches from '../components/extractionBatches/ExtractionBatches';
import TopBar from '../components/common/TopBar';
import errorResponses from '../errorResponses';
import useSetOrg from '../components/hooks/useSetOrg';
import { AppContext } from '../App';
import { ExtractionContextProvider } from '../context/ExtractionContext';
import { useParams } from 'react-router';
import { useSetTitle } from '../components/hooks/useSetTitle';

const ExtractionBatchPage = () => {
  const { dpid } = useParams<{ dpid: string }>();
  const { dataPoolLabel } = useContext(AppContext);

  const { loading, error } = useSetOrg(dpid);

  useSetTitle(`Extraction Batches - ${dataPoolLabel}`);

  if (loading) return <LinearProgress />;

  if (error) {
    return <ErrorPage error={errorResponses.invalidDataPool} />;
  }

  return (
    <div>
      <TopBar />
      <ExtractionContextProvider>
        <ExtractionBatches />
      </ExtractionContextProvider>
    </div>
  );
};
export default ExtractionBatchPage;
